import { defineStore } from 'pinia'

// NOTE: This state will overwrite all page content due Main component
// destruction and shouldn't be used to common loading cases like lists,
// the recommended way to do this kind of loading screen is using SkeletonLoader
// and local component state.
//
// But, if you need to load a global state for something this can be used, like
// currentSite inside the PanelLayout
export default defineStore('layout', {
  state: () => ({ loading: false }),
  actions: {
    setLoading (loading) {
      this.loading = loading
    }
  },
  getters: {
    isLoading () {
      return this.loading
    }
  }
})
